
  var _styles = {
  "coupon-card-double": {
    "display": "flex",
    "flexDirection": "column",
    "position": "relative",
    "width": "4.6rem",
    "height": "2.02667rem",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.21333rem",
    "overflow": "hidden",
    "marginBottom": "0.32rem",
    "paddingTop": 0,
    "paddingRight": "0.10667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.10667rem",
    "marginLeft": "0.08rem",
    "marginRight": "0.08rem"
  },
  "coupon-content-double": {
    "display": "flex",
    "flexDirection": "row",
    "paddingTop": "0.21333rem",
    "paddingRight": 0,
    "paddingBottom": "0.21333rem",
    "paddingLeft": 0,
    "borderRadius": "0.21333rem"
  },
  "left-section-double": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "1.93333rem",
    "marginTop": "-0.29333rem"
  },
  "price-wrapper-double": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "right-section-double": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "flex-start",
    "overflow": "hidden",
    "paddingLeft": "0.13333rem",
    "paddingRight": "0.13333rem",
    "flex": 1
  },
  "countdown-double": {
    "marginBottom": "0.16rem"
  }
};



  module.exports = _styles;
  